import Vision from '../components/Vision';
import { Box } from '@mui/material';

const VisionPage = () => {
  return (
    <Box sx={{ pt: 8 }}>
      <Vision />
    </Box>
  );
};

export default VisionPage;
